<template>
	<v-dialog
		v-model="dialog"
		max-width="700"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">工程詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-row no-gutters justify="end">
					<!-- v-if="authority == 'editable' && large_process.schedule_arrangement_flag" -->
					<ScheduleArrangementUserNewDialog :large_process="large_process" @add-user="addUser" />

					<v-btn
						class="mb-2 ml-2"
						color="secondary"
						v-if="authority == 'editable'"
						@click="editDialog = true"
					>
						<v-icon class="mr-1">mdi-pencil</v-icon>
						編集する
					</v-btn>
				</v-row>
				<table width="100%" class="show-dialog-table">
					<LargeProcessInfoUnit :large_process="large_process" :showEditBtn="false" />
				</table>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="8" />
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" @click="closeDialog()" text> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>

		<LargeProcessEditDialog
			ref="edit"
			:large_process="large_process"
			:dialog.sync="editDialog"
			:maxWidth="maxWidth"
			:toolbarTitle="toolbarTitle"
			:large_process_types="large_process_types"
			:current_company_name="current_company_name"
			disabled
			@update-large-process="updateLargeProcess($event)"
			@delete="closeDialog"
		/>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import common from "../../helper/common"
import moment from "moment"
import "moment/locale/ja"
import LargeProcessEditDialog from "./components/LargeProcessEditDialog"
import LargeProcessInfoUnit from "./components/LargeProcessInfoUnit"
import ScheduleArrangementUserNewDialog from "./components/ScheduleArrangementUserNewDialog"
import errorHandling from "../../helper/errorHandling"

export default {
	props: {
		current_company_name: {
			type: String,
			required: false,
		},
		large_process_types: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			moment.locale("ja")
			return moment(date).format("YYYY/MM/DD(dd)　HH:mm")
		},
	},
	components: {
		LargeProcessEditDialog,
		LargeProcessInfoUnit,
		ScheduleArrangementUserNewDialog,
	},
	data() {
		return {
			dialog: false,
			editDialog: false,
			id: null,
			errors: [],
			startDate: "",
			endDate: "",
			large_process: {
				large_process_type: {
					name: "",
				},
				large_process_values: [],
			},
			maxWidth: "900px",
			toolbarTitle: "工程編集",
			authority: null,
			scheduleArrangementDialog: false,
			situations_ja: {},
			common: common,
		}
	},
	mounted() {
		authenticate.authenticateUser()
	},

	methods: {
		addUser(schedule_arrangement_users) {
			schedule_arrangement_users.forEach((user) => {
				this.large_process.schedule_arrangement.schedule_arrangement_users.push(user)
			})
		},
		openDialog(id) {
			this.dialog = true
			this.fetchLargeProcess(id)
		},
		closeDialog() {
			this.dialog = false
		},
		fetchLargeProcess(id) {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/large_processes/${id}`, { headers })
				.then((res) => {
					this.large_process = res.data.large_process
					this.authority = res.data.authority
					this.$emit("update-process-product")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateLargeProcess(largeProcess) {
			this.large_process = largeProcess
			this.$emit("update-large-process", largeProcess)
		},
	},
}
</script>
